export default __webpack_public_path__ + "static/media/hero-image-mobile.4b1b7e20.png";